import { JSX } from 'react';
import { InfoColumns } from '../InfoColumns/InfoColumns';
import { ICommonProps } from '@/types/global';

export interface ITextColumnsProps extends ICommonProps {
  textCol1: string;
  textCol2: string;
  textCol3: string;
  textCol4: string;
}

/** Component InfoColumns only with texts
 * @param {ITextColumnsProps}
 * @returns {JSX.Element} - Rendered InfoColumns component
 */
export const TextColumns = ({
  textCol1 = '',
  textCol2 = '',
  textCol3 = '',
  textCol4 = '',
}: ITextColumnsProps): JSX.Element => {
  const columns: { type: 'text'; content: string }[] = [
    {
      type: 'text',
      content: textCol1,
    },
    {
      type: 'text',
      content: textCol2,
    },
    {
      type: 'text',
      content: textCol3,
    },
    {
      type: 'text',
      content: textCol4,
    },
  ];

  const hasContent = columns.some((col) => col.content.trim() !== '');

  return hasContent ? (
    <InfoColumns columns={columns} width={'content'} />
  ) : (
    <></>
  );
};
